var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _path14, _path15, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _path42, _path43, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 396 340",
    style: {
      enableBackground: "new 0 0 396 340"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;}\r\n\t.st1{fill-opacity:0;}\r\n\t.st2{opacity:9.090909e-02;enable-background:new    ;}\r\n\t.st3{opacity:0.1818;enable-background:new    ;}\r\n\t.st4{opacity:0.2727;enable-background:new    ;}\r\n\t.st5{opacity:0.3636;enable-background:new    ;}\r\n\t.st6{opacity:0.4545;enable-background:new    ;}\r\n\t.st7{opacity:0.5455;enable-background:new    ;}\r\n\t.st8{opacity:0.6364;enable-background:new    ;}\r\n\t.st9{opacity:0.7273;enable-background:new    ;}\r\n\t.st10{opacity:0.8182;enable-background:new    ;}\r\n\t.st11{opacity:0.9091;enable-background:new    ;}\r\n\t.st12{fill:url(#SVGID_1_);}\r\n\t.st13{fill:url(#SVGID_2_);}\r\n\t.st14{fill:url(#SVGID_3_);}\r\n\t.st15{fill:url(#SVGID_4_);}\r\n\t.st16{fill:url(#SVGID_5_);}\r\n\t.st17{fill:#1F0D3D;}\r\n\t.st18{fill:#3D065F;}\r\n\t.st19{fill:url(#SVGID_6_);}\r\n\t.st20{fill:url(#SVGID_7_);}\r\n\t.st21{fill:url(#SVGID_8_);}\r\n\t.st22{fill:url(#SVGID_9_);}\r\n\t.st23{fill:url(#SVGID_10_);}\r\n\t.st24{fill:#8443E3;}\r\n\t.st25{fill:#A56EF4;}\r\n\t.st26{fill:url(#SVGID_11_);}\r\n\t.st27{fill:url(#SVGID_12_);}\r\n\t.st28{fill:url(#SVGID_13_);}\r\n\t.st29{fill:url(#SVGID_14_);}\r\n\t.st30{fill:url(#SVGID_15_);}\r\n\t.st31{fill:url(#SVGID_16_);}\r\n\t.st32{fill:url(#SVGID_17_);}\r\n\t.st33{fill:url(#SVGID_18_);}\r\n\t.st34{fill:url(#SVGID_19_);}\r\n\t.st35{fill:url(#SVGID_20_);}\r\n\t.st36{fill:url(#SVGID_21_);}\r\n\t.st37{fill:url(#SVGID_22_);}\r\n\t.st38{fill:url(#SVGID_23_);}\r\n\t.st39{fill:url(#SVGID_24_);}\r\n\t.st40{fill:url(#SVGID_25_);}\r\n\t.st41{fill:url(#SVGID_26_);}\r\n\t.st42{fill:url(#SVGID_27_);}\r\n\t.st43{fill:url(#SVGID_28_);}\r\n\t.st44{fill:url(#SVGID_29_);}\r\n\t.st45{fill:url(#SVGID_30_);}\r\n\t.st46{fill:url(#SVGID_31_);}\r\n\t.st47{fill:url(#SVGID_32_);}\r\n\t.st48{fill:url(#SVGID_33_);}\r\n\t.st49{fill:#939598;}\r\n\t.st50{fill:url(#SVGID_34_);}\r\n\t.st51{fill:url(#SVGID_35_);}\r\n\t.st52{fill:url(#SVGID_36_);}\r\n\t.st53{fill:url(#SVGID_37_);}\r\n\t.st54{fill:url(#SVGID_38_);}\r\n\t.st55{fill:url(#SVGID_39_);}\r\n\t.st56{fill:url(#SVGID_40_);}\r\n\t.st57{fill:url(#SVGID_41_);}\r\n\t.st58{fill:url(#SVGID_42_);}\r\n\t.st59{fill:url(#SVGID_43_);}\r\n\t.st60{fill:url(#SVGID_44_);}\r\n\t.st61{fill:url(#SVGID_45_);}\r\n\t.st62{fill:url(#SVGID_46_);}\r\n\t.st63{fill:url(#SVGID_47_);}\r\n\t.st64{fill:url(#SVGID_48_);}\r\n\t.st65{fill:url(#SVGID_49_);}\r\n\t.st66{fill:url(#SVGID_50_);}\r\n\t.st67{fill:url(#SVGID_51_);}\r\n\t.st68{fill:url(#SVGID_52_);}\r\n\t.st69{fill:url(#SVGID_53_);}\r\n\t.st70{fill:url(#SVGID_54_);}\r\n\t.st71{fill:url(#SVGID_55_);}\r\n\t.st72{fill:url(#SVGID_56_);}\r\n\t.st73{fill:url(#SVGID_57_);}\r\n\t.st74{fill:url(#SVGID_58_);}\r\n\t.st75{fill:url(#SVGID_59_);}\r\n\t.st76{fill:url(#SVGID_60_);}\r\n\t.st77{fill:url(#SVGID_61_);}\r\n\t.st78{fill:url(#SVGID_62_);}\r\n\t.st79{fill:url(#SVGID_63_);}\r\n\t.st80{fill:url(#SVGID_64_);}\r\n\t.st81{fill:url(#SVGID_65_);}\r\n\t.st82{fill:url(#SVGID_66_);}\r\n\t.st83{fill:url(#SVGID_67_);}\r\n\t.st84{fill:url(#SVGID_68_);}\r\n\t.st85{fill:url(#SVGID_69_);}\r\n\t.st86{fill:url(#SVGID_70_);}\r\n\t.st87{fill:url(#SVGID_71_);}\r\n\t.st88{fill:url(#SVGID_72_);}\r\n\t.st89{fill:url(#SVGID_73_);}\r\n\t.st90{fill:url(#SVGID_74_);}\r\n\t.st91{fill:url(#SVGID_75_);}\r\n\t.st92{fill:url(#SVGID_76_);}\r\n\t.st93{fill:url(#SVGID_77_);}\r\n\t.st94{fill:url(#SVGID_78_);}\r\n\t.st95{fill:url(#SVGID_79_);}\r\n\t.st96{fill:url(#SVGID_80_);}\r\n\t.st97{fill:url(#SVGID_81_);}\r\n\t.st98{fill:url(#SVGID_82_);}\r\n\t.st99{fill:url(#SVGID_83_);}\r\n\t.st100{fill:url(#SVGID_84_);}\r\n\t.st101{fill:url(#SVGID_85_);}\r\n\t.st102{fill:url(#SVGID_86_);}\r\n\t.st103{fill:url(#SVGID_87_);}\r\n\t.st104{fill:url(#SVGID_88_);}\r\n\t.st105{fill:url(#SVGID_89_);}\r\n\t.st106{fill:url(#SVGID_90_);}\r\n\t.st107{fill:url(#SVGID_91_);}\r\n\t.st108{fill:url(#SVGID_92_);}\r\n\t.st109{fill:url(#SVGID_93_);}\r\n\t.st110{fill:url(#SVGID_94_);}\r\n\t.st111{fill:url(#SVGID_95_);}\r\n\t.st112{fill:url(#SVGID_96_);}\r\n\t.st113{fill:url(#SVGID_97_);}\r\n\t.st114{fill:url(#SVGID_98_);}\r\n\t.st115{fill:url(#SVGID_99_);}\r\n\t.st116{fill:url(#SVGID_100_);}\r\n\t.st117{fill:url(#SVGID_101_);}\r\n\t.st118{fill:url(#SVGID_102_);}\r\n\t.st119{fill:url(#SVGID_103_);}\r\n\t.st120{fill:url(#SVGID_104_);}\r\n\t.st121{fill:url(#SVGID_105_);}\r\n\t.st122{fill:url(#SVGID_106_);}\r\n\t.st123{fill:url(#SVGID_107_);}\r\n\t.st124{fill:url(#SVGID_108_);}\r\n\t.st125{fill:url(#SVGID_109_);}\r\n\t.st126{fill:url(#SVGID_110_);}\r\n\t.st127{fill:url(#SVGID_111_);}\r\n\t.st128{fill:url(#SVGID_112_);}\r\n\t.st129{fill:url(#SVGID_113_);}\r\n\t.st130{fill:url(#SVGID_114_);}\r\n\t.st131{fill:url(#SVGID_115_);}\r\n\t.st132{fill:url(#SVGID_116_);}\r\n\t.st133{fill:url(#SVGID_117_);}\r\n\t.st134{fill:url(#SVGID_118_);}\r\n\t.st135{fill:#D1D3D4;}\r\n\t.st136{fill:none;stroke:#8770B8;stroke-miterlimit:10;}\r\n\t.st137{fill:#8770B8;}\r\n\t.st138{fill:url(#SVGID_119_);}\r\n\t.st139{fill:url(#SVGID_120_);}\r\n\t.st140{fill:url(#SVGID_121_);}\r\n\t.st141{fill:url(#SVGID_122_);}\r\n\t.st142{fill:url(#SVGID_123_);}\r\n\t.st143{fill:url(#SVGID_124_);}\r\n\t.st144{fill:#FFFFFF;}\r\n\t.st145{fill:#EA990A;}\r\n\t.st146{fill:#D38620;}\r\n\t.st147{fill:#282027;}\r\n\t.st148{fill:#3D333B;}\r\n\t.st149{fill:#7C6B7C;}\r\n\t.st150{fill:#FFC85A;}\r\n\t.st151{fill:#5D80B3;}\r\n\t.st152{fill:#45649B;}\r\n\t.st153{fill:#FFDB9C;}\r\n\t.st154{fill:#FFBB27;}\r\n\t.st155{fill:#779CC9;}\r\n\t.st156{fill:#4C404A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.4,305.8c-5.4,0-10.3-1.2-14.2-3.4l-198-113.9c-5.2-3-8.2-7.7-8.2-13c0-5.8,3.6-11.1,9.8-14.7l85.4-49.3 c4.9-2.8,11-4.4,17.3-4.4c5.4,0,10.3,1.2,14.2,3.4l197.9,113.9c5.2,3,8.2,7.7,8.2,13c0,5.8-3.6,11.1-9.8,14.7l-85.4,49.3 C295.7,304.3,289.6,305.8,283.4,305.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,161.1L155,114c0.1-0.1,4.1-2.4,4.3-2.4c5-2.7,11.3-3.8,17.4-3.9c4.9-0.1,10.5,1.7,14,3.7l196.8,113.3 c5,2.9,7.8,7.4,7.8,12.4c0,5.5-3.5,10.6-9.4,14l-84.9,49c-1.8,1-4.2,2.1-6.3,2.8c-3.4,1.1-7.1,1.7-10.8,1.8 c-5.4,0.1-10.3-1.1-14.1-3.3l-198-113.9c-5-2.9-7.8-7.4-7.8-12.4C64.1,169.6,67.5,164.5,73.5,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.1,161.4l81.9-47.3c0.3-0.2,4-2.3,4.3-2.4c5.2-2.7,11.5-3.1,17.5-3.4c4.4-0.2,10.6,2.2,13.8,4.1 l195.8,112.7c4.8,2.8,7.4,7.1,7.4,11.8c0,5.2-3.3,10-9.1,13.3l-84.4,48.7c-1.6,0.9-4.4,2.2-6.2,2.8c-3.3,1.1-7,1.8-10.7,1.9 c-5.3,0.1-10.3-1-14.1-3.2L72.4,186.5c-4.8-2.8-7.4-7.1-7.4-11.8C65.1,169.6,68.4,164.7,74.1,161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.7,161.8l82.3-47.5c0.4-0.2,3.9-2.2,4.4-2.3c5.3-2.6,11.7-2.5,17.6-2.9c3.9-0.2,10.8,2.7,13.6,4.4 l194.7,112c4.6,2.6,7.1,6.7,7,11.2c-0.1,4.9-3.2,9.5-8.7,12.6l-83.8,48.4c-1.4,0.8-4.5,2.3-6.2,2.9c-3.3,1.1-6.9,1.9-10.6,2 c-5.3,0.2-10.2-0.9-14-3.1L73,185.6c-4.6-2.6-7.1-6.7-7-11.2C66.1,169.5,69.2,164.9,74.7,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.3,162.1l82.7-47.7c0.5-0.3,3.8-2.1,4.4-2.3c5.4-2.5,12-1.9,17.7-2.4c3.4-0.3,10.9,3.3,13.4,4.7L387,225.8 c4.4,2.5,6.7,6.4,6.6,10.6c-0.1,4.6-3.1,8.9-8.3,11.9L302,296.4c-1.2,0.7-4.7,2.4-6.1,2.9c-3.3,1.2-6.8,2-10.5,2.2 c-5.2,0.2-10.2-0.8-13.9-3L73.6,184.6c-4.4-2.5-6.7-6.4-6.6-10.6C67.1,169.5,70.1,165.1,75.3,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,162.4l83.1-48c0.7-0.4,3.7-2,4.4-2.3c5.5-2.4,12.2-1.3,17.8-1.9c2.9-0.3,11.1,3.8,13.2,5L386.9,226 c4.2,2.4,6.4,6,6.3,10c-0.1,4.3-2.9,8.3-7.9,11.2L302.5,295c-1.1,0.6-4.8,2.5-6,3c-3.2,1.2-6.8,2.1-10.4,2.3 c-5.2,0.3-10.1-0.7-13.8-2.8L74.2,183.6c-4.2-2.4-6.4-6-6.3-10C68.1,169.4,70.9,165.3,75.9,162.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.5,162.8l83.5-48.2c0.8-0.5,3.6-1.9,4.5-2.2c5.7-2.3,12.4-0.7,17.9-1.4c2.4-0.3,11.2,4.3,13,5.3 l191.4,110.2c4,2.3,6,5.7,5.9,9.4c-0.1,4-2.8,7.8-7.5,10.5l-82.3,47.5c-0.9,0.5-4.9,2.6-6,3c-3.2,1.2-6.7,2.2-10.3,2.4 c-5.1,0.3-10.1-0.6-13.8-2.7l-198-113.9c-4-2.3-6-5.7-5.9-9.4C69.1,169.3,71.7,165.5,76.5,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M77.1,163.1l83.8-48.4c0.9-0.5,3.5-1.8,4.5-2.2c5.8-2.3,12.6,0,18-0.9c1.9-0.3,11.4,4.8,12.8,5.6l190.3,109.5 c3.8,2.2,5.7,5.4,5.5,8.8c-0.2,3.7-2.7,7.2-7.2,9.8L303,292.5c-0.7,0.4-5.1,2.8-5.9,3.1c-3.1,1.2-6.6,2.3-10.2,2.6 c-5.1,0.4-10.1-0.5-13.7-2.6L75.4,181.7c-3.8-2.2-5.7-5.4-5.5-8.8C70.1,169.3,72.6,165.7,77.1,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M77.7,163.5l84.2-48.6c1-0.6,3.4-1.8,4.6-2.1c5.9-2.2,13-2.4,18.1-0.4c1.5,0,11.5,5.3,12.6,6l189.2,108.9 c3.6,2,5.3,5,5.1,8.2c-0.2,3.4-2.6,6.6-6.8,9.1l-81.3,46.9c-0.5,0.3-5.2,2.9-5.8,3.1c-3.1,1.2-6.5,2.4-10.1,2.7 c-5.1,0.4-10-0.4-13.6-2.5L76,180.8c-3.6-2-5.3-5-5.1-8.2C71.1,169.2,73.4,165.9,77.7,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M78.3,163.8l84.6-48.8c1.2-0.7,3.3-1.7,4.6-2.1c6.1-2.1,13.3-2.1,18.2,0.1c1,0,11.7,5.9,12.4,6.3l188.1,108.3 c3.3,1.9,5,4.7,4.7,7.6c-0.2,3-2.4,6.1-6.4,8.4l-80.8,46.6c-0.4,0.2-5.3,3-5.7,3.2c-3.1,1.3-6.4,2.5-10,2.8c-5,0.5-10-0.3-13.6-2.4 l-197.8-114c-3.3-1.9-5-4.7-4.7-7.6C72.1,169.1,74.3,166.1,78.3,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M78.8,164.1l85-49.1c1.3-0.8,3.1-1.6,4.7-2.1c6.2-2,13.5-1.9,18.4,0.6c0.5,0,11.9,6.4,12.2,6.6l187,107.6 c3.1,1.8,4.6,4.4,4.4,7c-0.2,2.7-2.3,5.5-6,7.7l-80.3,46.3c-0.2,0.1-5.5,3.1-5.7,3.2c-3,1.3-6.4,2.6-9.9,2.9 c-5,0.5-10-0.2-13.5-2.2L77.2,178.8c-3.1-1.8-4.6-4.4-4.4-7C73.1,169.1,75.1,166.3,78.8,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,291.8L77.8,177.9c-5.9-3.4-5.2-9.4,1.7-13.4l85.4-49.3c6.9-4,17.2-4.4,23.2-1L386,228.1c5.9,3.4,5.2,9.4-1.7,13.4 l-85.4,49.3C292,294.8,281.7,295.2,275.7,291.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1346.0219,
    y1: 294.8215,
    x2: 1663.2969,
    y2: 294.8215,
    gradientTransform: "matrix(1 0 0 1 -1274.2094 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F054A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5824B0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M303.2,277.9l79.8-46.1c9-5.2,7.9-14.3-2.5-20.3L192.8,103.2c-10.4-6-26.1-6.7-35.1-1.5l-79.8,46.1 c-9,5.2-7.9,14.3,2.5,20.3l187.7,108.4C278.5,282.5,294.2,283.1,303.2,277.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1387.7223,
    y1: 293.45,
    x2: 1705.0223,
    y2: 293.45,
    gradientTransform: "matrix(1 0 0 1 -1274.2094 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0555556,
    style: {
      stopColor: "#2F0D5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#2F105F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4697,
    style: {
      stopColor: "#311B61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    style: {
      stopColor: "#351F65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4954,
    style: {
      stopColor: "#422C73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5093,
    style: {
      stopColor: "#584188"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    style: {
      stopColor: "#765FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    style: {
      stopColor: "#8770B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    style: {
      stopColor: "#7E67AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5617,
    style: {
      stopColor: "#5C468D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    style: {
      stopColor: "#442E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    style: {
      stopColor: "#362066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    style: {
      stopColor: "#311B61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#2A1155"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    style: {
      stopColor: "#230446"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    style: {
      stopColor: "#200041"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#200041"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M303.2,276.6l79.8-46.1c4-2.3,6-5.4,6.1-8.7c0-0.3,0-6.5,0-6.8c-0.3-3.8-3.2-1.7-8.6-4.8L192.8,101.8 c-10.4-6-26.1-6.7-35.1-1.5l-79.8,46.1c-4,2.3-6-1.8-6.1,1.5c0,0.3,0,7.7,0,8c0.3,3.8,3.2,7.7,8.6,10.8l187.7,108.4 C278.5,281.1,294.2,281.8,303.2,276.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1346.0219,
    y1: 286.6215,
    x2: 1663.2969,
    y2: 286.6215,
    gradientTransform: "matrix(1 0 0 1 -1274.2094 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58098A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E3BDB"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M303.2,269.7l79.8-46.1c9-5.2,7.9-14.3-2.5-20.3L192.8,95c-10.4-6-26.1-6.7-35.1-1.5l-79.8,46.1 c-9,5.2-7.9,14.3,2.5,20.3l187.7,108.4C278.5,274.3,294.2,274.9,303.2,269.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 5801.7739,
    cy: 321.72,
    r: 120.6114,
    gradientTransform: "matrix(-1 0 0 1 6053.4673 -105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M383,222.7l-79.8,46.1c-9,5.2-24.7,4.5-35.1-1.5L80.4,159c-5.5-3.2-8.4-7.2-8.6-11c-0.2,4.1,2.7,8.5,8.6,11.9 l187.7,108.4c10.4,6,26.1,6.7,35.1,1.5l79.8-46.1c4.3-2.5,6.3-5.8,6.1-9.3C388.9,217.5,386.9,220.5,383,222.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1349.178,
    y1: 286.6,
    x2: 1660.1407,
    y2: 286.6,
    gradientTransform: "matrix(1 0 0 1 -1274.2094 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F054A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E1D9A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M378.4,204.7L190.5,96.2c-9.1-5.3-22.9-5.8-30.8-1.3l-79.4,45.8c-7.9,4.6-6.9,12.5,2.2,17.8L270.4,267 c9.1,5.3,22.9,5.8,30.8,1.3l79.4-45.8C388.5,217.9,387.5,210,378.4,204.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M374.8,206.3l-187-108c-7.6-4.4-19.2-4.9-25.8-1.1l-77.7,44.9c-6.6,3.8-5.8,10.5,1.9,14.9l187,108 c7.6,4.4,19.2,4.9,25.8,1.1l77.7-44.9C383.2,217.3,382.4,210.7,374.8,206.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M162.7,98.7c6.2-3.6,16.3-3.6,22.5,0l189,109.1c6.2,3.6,6.2,9.4-0.1,13l-75.9,43.8c-6.2,3.6-16.3,3.6-22.5,0 l-189-109.1c-6.2-3.6-6.2-9.4,0.1-13L162.7,98.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 5838.8882,
    y1: 207.4962,
    x2: 5783.811,
    y2: 482.882,
    gradientTransform: "matrix(-1 0 0 1 6053.4673 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#861EB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    style: {
      stopColor: "#5F27BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#3D065F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M286.9,265.7c-4,0-7.7-0.9-10.4-2.5l-189-109.1c-2.5-1.4-3.9-3.3-3.9-5.1c0-1.9,1.4-3.7,3.9-5.2l75.9-43.8 c2.8-1.6,6.5-2.5,10.5-2.5s7.7,0.9,10.4,2.5l189,109.1c2.5,1.4,3.9,3.3,3.9,5.1c0,1.9-1.4,3.7-3.9,5.2l-75.9,43.8 C294.7,264.9,290.9,265.7,286.9,265.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1258.7028,
    y1: 1974.4423,
    x2: 1273.9944,
    y2: 1974.4423,
    gradientTransform: "matrix(0.866 0.5 0.5 1.4434 -1957.8525 -3292.7478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D065F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F27BD"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M130.4,195.5l-8.7-5c-1.1-0.6-2-2.3-2-3.8l0,0c0-1.4,0.9-2.1,2-1.5l8.7,5c1.1,0.6,2,2.3,2,3.8l0,0 C132.4,195.5,131.5,196.2,130.4,195.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1258.7028,
    y1: 1974.4423,
    x2: 1273.9944,
    y2: 1974.4423,
    gradientTransform: "matrix(0.866 0.5 0.5 1.4434 -1957.8525 -3292.7478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F054A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5824B0"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M130.4,195.5l-8.7-5c-1.1-0.6-2-2.3-2-3.8l0,0c0-1.4,0.9-2.1,2-1.5l8.7,5c1.1,0.6,2,2.3,2,3.8l0,0 C132.4,195.5,131.5,196.2,130.4,195.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1242.0892,
    y1: 2019.8358,
    x2: 1235.7625,
    y2: 2031.6343,
    gradientTransform: "matrix(0.866 0.5 0.5 1.4434 -1957.8525 -3292.7478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0555556,
    style: {
      stopColor: "#9F79B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#A17BBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3569,
    style: {
      stopColor: "#A783BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4338,
    style: {
      stopColor: "#B290C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4949,
    style: {
      stopColor: "#C1A1D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5067,
    style: {
      stopColor: "#C4A5D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    style: {
      stopColor: "#CDB3DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5329,
    style: {
      stopColor: "#DBC8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5466,
    style: {
      stopColor: "#EFE7F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5556,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#ECE0F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5801,
    style: {
      stopColor: "#DDC8EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    style: {
      stopColor: "#D4B9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#D1B4E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    style: {
      stopColor: "#B395D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7155,
    style: {
      stopColor: "#9C7DCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    style: {
      stopColor: "#8E6EC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    style: {
      stopColor: "#8969C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B086CC"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M131.2,195.3c-0.2,0-0.3-0.1-0.5-0.2l-8.7-5c-0.9-0.5-1.7-2.1-1.7-3.3c0-0.6,0.2-1.2,0.7-1.2 c0.2,0,0.3,0.1,0.5,0.2l8.7,5c0.9,0.5,1.7,2.1,1.7,3.3C131.9,194.6,131.7,195.3,131.2,195.3z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M207.2,233.3L80.4,159.7c-5.4-3.1-8.2-7-8.6-10.8c0-0.1,0-1.6,0-3.3c0,0,0,7.8,0,8.1c0.3,3.8,3.2,7.7,8.6,10.8 L207.2,233.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M350.4,248.7l-14.3,8.2l0,0c0-2.6,1.6-5.6,3.5-6.8l7.2-4.2C348.8,244.9,350.4,246.1,350.4,248.7L350.4,248.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 6885.1328,
    y1: 1250.3297,
    x2: 7065.8335,
    y2: 1209.8225,
    gradientTransform: "matrix(0.433 -0.75 1 0.5774 -3984.0525 4742.021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#6B24D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1421,
    style: {
      stopColor: "#6633D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3489,
    style: {
      stopColor: "#5A5CE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    style: {
      stopColor: "#459DEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "335.2,241.3 356.2,229.6 345.5,226.8 292.6,227.2 246.7,215.4 230.7,209.3 177.9,206.3 225.1,233.5  246.2,236.4 264.1,235.5 281.4,238.4 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M352,196.7l-5.1-2.9l-14.2,7.6l-38.8-22.3l13.9-7.9l-5-2.9l-13.9,7.9l-42.6-24.5l14-8l-5-2.9l-96,54.7l5,2.9 l77-43.9l42.6,24.5l-27.3,15.6l2.5,4.3l29.9-17.1l38.7,22.2l-22.1,12l-30-17.9l-2.6,4.3l30.4,18.1l0.3,39.2l5-2.9l-0.3-35.2 l50.1,0.4l5.2,3l5-2.9l-30.9-17.8L352,196.7z M349.6,216.9l-34.7-0.3l17.7-9.5L349.6,216.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M268.3,258.1L251.9,248l12.4-6.8l1.7-34.9l-24.7-15.8l-20,12.7c-1.9,1.2-4.3,1.2-6.2,0.1L142.4,161l9.3-8.5 l66.3,38.6l20.2-12.8c2-1.2,4.5-1.2,6.5,0l30.8,19.8c1.8,1.2,2.9,3.2,2.8,5.3l-2,40.8c-0.1,1.5-0.7,2.9-1.8,4L268.3,258.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "212.8,116.4 116.8,171.1 121.8,174 217.8,119.3 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.3378,
    y1: 187.939,
    x2: 286.4615,
    y2: 155.2635,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "171.4,41 171.4,136.3 199.9,119.9 199.9,24.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.3641,
    y1: 210.1053,
    x2: 190.2051,
    y2: 178.0849,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "171.4,41 171.4,136.3 143.3,119.9 143.3,24.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.35,
    y1: 230.2972,
    x2: 150.35,
    y2: 143.9578,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "151.9,33.4 148.8,31.6 148.8,119.8 151.9,121.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.95,
    y1: 229.7198,
    x2: 156.95,
    y2: 143.3803,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "158.5,37.3 155.4,35.5 155.4,123.6 158.5,125.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.6,
    y1: 229.1424,
    x2: 163.6,
    y2: 142.8028,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "165.1,41.2 162.1,39.4 162.1,127.5 165.1,129.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 8630.8623,
    y1: 224.5703,
    x2: 8630.8623,
    y2: 139.002,
    gradientTransform: "matrix(-1 0 0 1 8823.3125 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "190.9,33.5 194,31.7 194,119.8 190.9,121.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 8637.3623,
    y1: 223.9446,
    x2: 8637.3623,
    y2: 138.3763,
    gradientTransform: "matrix(-1 0 0 1 8823.3125 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "184.4,37.3 187.5,35.5 187.5,123.6 184.4,125.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 8643.8623,
    y1: 223.3189,
    x2: 8643.8623,
    y2: 137.7507,
    gradientTransform: "matrix(-1 0 0 1 8823.3125 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "177.9,41.2 181,39.4 181,127.5 177.9,129.3  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.0804,
    y1: 73.4166,
    x2: 169.373,
    y2: 133.8441,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "143.3,24.6 171.4,41 199.9,24.6 171.7,8.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.0344,
    y1: 130.0928,
    x2: 220.4758,
    y2: 117.0849,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "171.5,22.8 171.5,35.6 189.2,25.4 189.2,12.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.0971,
    y1: 135.2989,
    x2: 191.5546,
    y2: 122.643,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "171.5,22.8 171.5,35.6 154,25.4 154,12.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.7,
    y1: 131.612,
    x2: 157.7,
    y2: 122.2374,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#138BBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    style: {
      stopColor: "#169AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    style: {
      stopColor: "#1FC3DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "158.9,17.9 156.5,16.4 156.5,24.8 158.9,26.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.5,
    y1: 133.9309,
    x2: 162.5,
    y2: 124.5818,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#138BBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    style: {
      stopColor: "#169AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    style: {
      stopColor: "#1FC3DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "163.7,20.7 161.3,19.3 161.3,27.6 163.7,29  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.3,
    y1: 136.2524,
    x2: 167.3,
    y2: 126.9288,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#138BBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    style: {
      stopColor: "#169AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    style: {
      stopColor: "#1FC3DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "168.5,23.5 166.1,22.1 166.1,30.4 168.5,31.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 8619.7773,
    y1: 131.4743,
    x2: 8619.7773,
    y2: 122.2267,
    gradientTransform: "matrix(-1 0 0 1 8805.127 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#138BBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    style: {
      stopColor: "#169AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    style: {
      stopColor: "#1FC3DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "184.2,17.7 186.5,16.4 186.5,24.8 184.2,26.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 8624.627,
    y1: 133.8653,
    x2: 8624.627,
    y2: 124.5797,
    gradientTransform: "matrix(-1 0 0 1 8805.127 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#138BBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    style: {
      stopColor: "#169AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    style: {
      stopColor: "#1FC3DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "179.3,20.6 181.7,19.3 181.7,27.6 179.3,28.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 8629.4268,
    y1: 136.2524,
    x2: 8629.4268,
    y2: 126.9288,
    gradientTransform: "matrix(-1 0 0 1 8805.127 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#138BBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    style: {
      stopColor: "#169AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    style: {
      stopColor: "#1FC3DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "174.5,23.5 176.9,22.1 176.9,30.4 174.5,31.8  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.9719,
    y1: 82.5867,
    x2: 170.213,
    y2: 120.2433,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "154,12.6 171.5,22.8 189.2,12.6 171.7,2.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.402,
    y1: 117.5084,
    x2: 196.9376,
    y2: 110.7605,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "171.5,11.3 171.5,18 180.7,12.7 180.7,6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.6679,
    y1: 120.2128,
    x2: 181.9572,
    y2: 113.647,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "171.5,11.3 171.5,18 162.5,12.7 162.5,6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.6487,
    y1: 114.4346,
    x2: 194.0017,
    y2: 108.6396,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#6B24D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    style: {
      stopColor: "#7733DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    style: {
      stopColor: "#975CED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56EF4"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "171.5,11.3 171.5,12 180.7,6.7 180.7,6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.735,
    y1: 116.7494,
    x2: 179.8058,
    y2: 111.1293,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#6B24D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    style: {
      stopColor: "#7733DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    style: {
      stopColor: "#975CED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56EF4"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "171.5,11.3 171.5,12 162.5,6.7 162.5,6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.1092,
    y1: 92.8774,
    x2: 170.8824,
    y2: 112.3676,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "162.5,6 171.5,11.3 180.7,6 171.6,0.7  "
  }))), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "143.3,119.9 161,130.3 161,54.5 143.3,44.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.586,
    y1: 254.0562,
    x2: 212.5716,
    y2: 232.8006,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "130.5,154.1 130.5,159.8 163.4,140.8 163.4,135.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.2951,
    y1: 262.5387,
    x2: 161.3018,
    y2: 241.9137,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "130.5,154.1 130.5,159.8 98.1,140.8 98.1,135.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.798,
    y1: 175.2115,
    x2: 128.1565,
    y2: 245.0427,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "98.1,135.1 130.5,154.1 163.4,135.1 130.9,116.2  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.7509,
    y1: 206.0452,
    x2: 242.6736,
    y2: 174.3283,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "130.5,62.2 130.5,151.5 159,135.1 159,45.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.7276,
    y1: 218.8536,
    x2: 187.3261,
    y2: 187.7843,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "130.6,62.2 130.6,151.5 102.5,135.1 102.5,45.8 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8775,
    x2: 116.55,
    y2: 164.8661,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "128.1,63.8 105,50.3 105,53.5 128.1,67  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8775,
    x2: 116.55,
    y2: 164.8661,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "128.1,70.3 105,56.8 105,60.1 128.1,73.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8774,
    x2: 116.55,
    y2: 164.866,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "128.1,76.9 105,63.4 105,66.7 128.1,80.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8774,
    x2: 116.55,
    y2: 164.866,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "128.1,83.5 105,70 105,73.2 128.1,86.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8773,
    x2: 116.55,
    y2: 164.866,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "128.1,90 105,76.6 105,79.8 128.1,93.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8773,
    x2: 116.55,
    y2: 164.866,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "128.1,96.6 105,83.1 105,86.4 128.1,99.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8773,
    x2: 116.55,
    y2: 164.866,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "128.1,103.2 105,89.7 105,92.9 128.1,106.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8772,
    x2: 116.55,
    y2: 164.8661,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "128.1,109.8 105,96.3 105,99.5 128.1,113  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8772,
    x2: 116.55,
    y2: 164.8661,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "128.1,116.3 105,102.8 105,106.1 128.1,119.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8772,
    x2: 116.55,
    y2: 164.8661,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "128.1,122.9 105,109.4 105,112.6 128.1,126.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8772,
    x2: 116.55,
    y2: 164.8662,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "128.1,129.5 105,116 105,119.2 128.1,132.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8772,
    x2: 116.55,
    y2: 164.8662,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "128.1,136 105,122.6 105,125.8 128.1,139.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.55,
    y1: 246.8772,
    x2: 116.55,
    y2: 164.8663,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "128.1,142.6 105,129.1 105,132.4 128.1,145.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2198,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "133.4,63.8 156.6,50.3 156.6,53.5 133.4,67  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2198,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "133.4,70.3 156.6,56.8 156.6,60.1 133.4,73.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2198,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "133.4,76.9 156.6,63.4 156.6,66.7 133.4,80.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2197,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "133.4,83.5 156.6,70 156.6,73.2 133.4,86.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2197,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "133.4,90 156.6,76.6 156.6,79.8 133.4,93.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2197,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "133.4,96.6 156.6,83.1 156.6,86.4 133.4,99.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2196,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "133.4,103.2 156.6,89.7 156.6,92.9 133.4,106.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2196,
    x2: 239.6152,
    y2: 160.1688,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "133.4,109.8 156.6,96.3 156.6,99.5 133.4,113  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2196,
    x2: 239.6152,
    y2: 160.1689,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "133.4,116.3 156.6,102.8 156.6,106.1 133.4,119.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2196,
    x2: 239.6152,
    y2: 160.1689,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "133.4,122.9 156.6,109.4 156.6,112.6 133.4,126.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2196,
    x2: 239.6152,
    y2: 160.1689,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "133.4,129.5 156.6,116 156.6,119.2 133.4,132.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2196,
    x2: 239.6152,
    y2: 160.169,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "133.4,136 156.6,122.6 156.6,125.8 133.4,139.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6152,
    y1: 243.2196,
    x2: 239.6152,
    y2: 160.1691,
    gradientTransform: "matrix(-1 0 0 1 384.6152 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "133.4,142.6 156.6,129.1 156.6,132.4 133.4,145.9  "
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.2337,
    y1: 94.6102,
    x2: 128.5264,
    y2: 155.0377,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "102.5,45.8 130.6,62.2 159,45.8 130.9,29.4 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 8670.5693,
    y1: 9359.623,
    x2: 8648.1211,
    y2: 9402.4043,
    gradientTransform: "matrix(-1 0 0 -1 8780.4463 9445.1016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "150.8,45.7 130.9,34.1 110.7,45.7 130.6,57.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.0841,
    y1: 151.6863,
    x2: 142.3868,
    y2: 139.204,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "130.9,37.5 130.9,34.1 130.9,34.1 110.7,45.7 113.7,47.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.3876,
    y1: 146.6079,
    x2: 150.4404,
    y2: 140.9017,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "130.9,37.5 147.8,47.4 150.8,45.7 130.9,34.1  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.625,
    y1: 210.6928,
    x2: 327.7486,
    y2: 178.0174,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "212.7,63.7 212.7,159.1 241.2,142.7 241.2,47.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.7766,
    y1: 223.9134,
    x2: 271.618,
    y2: 191.8929,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "212.7,63.7 212.7,159.1 184.6,142.7 184.6,47.4 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7858,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M207.2,63.7v3.2l2.7,1.7v-3.2L207.2,63.7z M202.2,64l2.7,1.7v-3.2l-2.7-1.7V64z M187.2,55.3l2.7,1.7v-3.2 l-2.7-1.7V55.3z M192.2,58.2l2.7,1.7v-3.2l-2.7-1.7V58.2z M197.2,61.1l2.7,1.7v-3.2l-2.7-1.7V61.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M207.2,70.4v3.2l2.7,1.7v-3.2L207.2,70.4z M202.2,70.7l2.7,1.7v-3.2l-2.7-1.7V70.7z M187.2,62.1l2.7,1.7v-3.2 l-2.7-1.7V62.1z M192.2,64.9l2.7,1.7v-3.2l-2.7-1.7V64.9z M197.2,67.8l2.7,1.7v-3.2l-2.7-1.7V67.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M207.2,77.1v3.2l2.7,1.7v-3.2L207.2,77.1z M202.2,77.4l2.7,1.7v-3.2l-2.7-1.7V77.4z M187.2,68.8l2.7,1.7v-3.2 l-2.7-1.7V68.8z M192.2,71.6l2.7,1.7v-3.2l-2.7-1.7V71.6z M197.2,74.5l2.7,1.7V73l-2.7-1.7V74.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M207.2,83.8V87l2.7,1.7v-3.2L207.2,83.8z M202.2,84.1l2.7,1.7v-3.2l-2.7-1.7V84.1z M187.2,75.5l2.7,1.7V74 l-2.7-1.7V75.5z M192.2,78.4l2.7,1.7v-3.2l-2.7-1.7V78.4z M197.2,81.2l2.7,1.7v-3.2l-2.7-1.7V81.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M207.2,90.6v3.2l2.7,1.7v-3.2L207.2,90.6z M202.2,90.8l2.7,1.7v-3.2l-2.7-1.7V90.8z M187.2,82.2l2.7,1.7v-3.2 l-2.7-1.7V82.2z M192.2,85.1l2.7,1.7v-3.2l-2.7-1.7V85.1z M197.2,88l2.7,1.7v-3.2l-2.7-1.7V88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M207.2,97.3v3.2l2.7,1.7V99L207.2,97.3z M202.2,97.5l2.7,1.7V96l-2.7-1.7V97.5z M187.2,88.9l2.7,1.7v-3.2 l-2.7-1.7V88.9z M192.2,91.8l2.7,1.7v-3.2l-2.7-1.7V91.8z M197.2,94.7l2.7,1.7v-3.2l-2.7-1.7V94.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M207.2,104v3.2l2.7,1.7v-3.2L207.2,104z M202.2,104.3l2.7,1.7v-3.2l-2.7-1.7V104.3z M187.2,95.6l2.7,1.7v-3.2 l-2.7-1.7V95.6z M192.2,98.5l2.7,1.7V97l-2.7-1.7V98.5z M197.2,101.4l2.7,1.7v-3.2l-2.7-1.7V101.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M207.2,110.7v3.2l2.7,1.7v-3.2L207.2,110.7z M202.2,111l2.7,1.7v-3.2l-2.7-1.7V111z M187.2,102.3l2.7,1.7 v-3.2l-2.7-1.7V102.3z M192.2,105.2l2.7,1.7v-3.2l-2.7-1.7V105.2z M197.2,108.1l2.7,1.7v-3.2l-2.7-1.7V108.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7167,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M207.2,117.4v3.2l2.7,1.7v-3.2L207.2,117.4z M202.2,117.7l2.7,1.7v-3.2l-2.7-1.7V117.7z M187.2,109l2.7,1.7 v-3.2l-2.7-1.7V109z M192.2,111.9l2.7,1.7v-3.2l-2.7-1.7V111.9z M197.2,114.8l2.7,1.7v-3.2l-2.7-1.7V114.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7166,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M207.2,124.1v3.2l2.7,1.7v-3.2L207.2,124.1z M202.2,124.4l2.7,1.7v-3.2l-2.7-1.7V124.4z M187.2,115.8l2.7,1.7 v-3.2l-2.7-1.7V115.8z M192.2,118.6l2.7,1.7v-3.2l-2.7-1.7V118.6z M197.2,121.5l2.7,1.7V120l-2.7-1.7V121.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7857,
    x2: 198.55,
    y2: 167.7166,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M207.2,130.8v3.2l2.7,1.7v-3.2L207.2,130.8z M202.2,131.1l2.7,1.7v-3.2l-2.7-1.7V131.1z M187.2,122.5l2.7,1.7 V121l-2.7-1.7V122.5z M192.2,125.3l2.7,1.7v-3.2l-2.7-1.7V125.3z M197.2,128.2l2.7,1.7v-3.2l-2.7-1.7V128.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7856,
    x2: 198.55,
    y2: 167.7166,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M207.2,137.5v3.2l2.7,1.7v-3.2L207.2,137.5z M202.2,137.8l2.7,1.7v-3.2l-2.7-1.7V137.8z M187.2,129.2l2.7,1.7 v-3.2l-2.7-1.7V129.2z M192.2,132.1l2.7,1.7v-3.2l-2.7-1.7V132.1z M197.2,134.9l2.7,1.7v-3.2l-2.7-1.7V134.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.55,
    y1: 250.7856,
    x2: 198.55,
    y2: 167.7166,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M207.2,144.2v3.2l2.7,1.7v-3.2L207.2,144.2z M202.2,144.5l2.7,1.7V143l-2.7-1.7V144.5z M187.2,135.9l2.7,1.7 v-3.2l-2.7-1.7V135.9z M192.2,138.8l2.7,1.7v-3.2l-2.7-1.7V138.8z M197.2,141.7l2.7,1.7v-3.2l-2.7-1.7V141.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.8761,
    y1: 242.8576,
    x2: 234.1319,
    y2: 133.7064,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M238.5,52.2l-2.7,1.7V57l2.7-1.7V52.2z M233.5,55.1l-2.7,1.7V60l2.7-1.7V55.1z M228.5,57.9l-2.7,1.7v3.2 l2.7-1.7V57.9z M215.7,65.4v3.2l2.7-1.7v-3.2L215.7,65.4z M223.5,60.8l-2.7,1.7v3.2l2.7-1.7V60.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.3055,
    y1: 243.1753,
    x2: 235.5614,
    y2: 134.024,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M238.5,58.9l-2.7,1.7v3.2l2.7-1.7V58.9z M233.5,61.8l-2.7,1.7v3.2l2.7-1.7V61.8z M228.5,64.7l-2.7,1.7v3.2 l2.7-1.7V64.7z M215.7,72.1v3.2l2.7-1.7v-3.2L215.7,72.1z M223.5,67.5l-2.7,1.7v3.2l2.7-1.7V67.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.7243,
    y1: 243.4905,
    x2: 236.9801,
    y2: 134.3393,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M238.5,65.6l-2.7,1.7v3.2l2.7-1.7V65.6z M233.5,68.5l-2.7,1.7v3.2l2.7-1.7V68.5z M228.5,71.4l-2.7,1.7v3.2 l2.7-1.7V71.4z M215.7,78.8V82l2.7-1.7v-3.2L215.7,78.8z M223.5,74.2l-2.7,1.7v3.2l2.7-1.7V74.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.1432,
    y1: 243.8058,
    x2: 238.399,
    y2: 134.6545,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M238.5,72.3l-2.7,1.7v3.2l2.7-1.7V72.3z M233.5,75.2l-2.7,1.7V80l2.7-1.7V75.2z M228.5,78.1l-2.7,1.7V83 l2.7-1.7V78.1z M215.7,85.5v3.2l2.7-1.7v-3.2L215.7,85.5z M223.5,81l-2.7,1.7v3.2l2.7-1.7V81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.562,
    y1: 244.121,
    x2: 239.8178,
    y2: 134.9698,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M238.5,79l-2.7,1.7v3.2l2.7-1.7V79z M233.5,81.9l-2.7,1.7v3.2l2.7-1.7V81.9z M228.5,84.8l-2.7,1.7v3.2 l2.7-1.7V84.8z M215.7,92.2v3.2l2.7-1.7v-3.2L215.7,92.2z M223.5,87.7l-2.7,1.7v3.2l2.7-1.7V87.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.9808,
    y1: 244.4364,
    x2: 241.2366,
    y2: 135.2851,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M238.5,85.7l-2.7,1.7v3.2l2.7-1.7V85.7z M233.5,88.6l-2.7,1.7v3.2l2.7-1.7V88.6z M228.5,91.5l-2.7,1.7v3.2 l2.7-1.7V91.5z M215.7,98.9v3.2l2.7-1.7v-3.2L215.7,98.9z M223.5,94.4l-2.7,1.7v3.2l2.7-1.7V94.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.4208,
    y1: 244.7563,
    x2: 242.6766,
    y2: 135.6051,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M238.5,92.5l-2.7,1.7v3.2l2.7-1.7V92.5z M233.5,95.3l-2.7,1.7v3.2l2.7-1.7V95.3z M228.5,98.2l-2.7,1.7v3.2 l2.7-1.7V98.2z M215.7,105.7v3.2l2.7-1.7V104L215.7,105.7z M223.5,101.1l-2.7,1.7v3.2l2.7-1.7V101.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.8397,
    y1: 245.0716,
    x2: 244.0955,
    y2: 135.9203,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M238.5,99.2l-2.7,1.7v3.2l2.7-1.7V99.2z M233.5,102l-2.7,1.7v3.2l2.7-1.7V102z M228.5,104.9l-2.7,1.7v3.2 l2.7-1.7V104.9z M215.7,112.4v3.2l2.7-1.7v-3.2L215.7,112.4z M223.5,107.8l-2.7,1.7v3.2l2.7-1.7V107.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.2585,
    y1: 245.3868,
    x2: 245.5143,
    y2: 136.2356,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M238.5,105.9l-2.7,1.7v3.2l2.7-1.7V105.9z M233.5,108.8l-2.7,1.7v3.2l2.7-1.7V108.8z M228.5,111.6l-2.7,1.7 v3.2l2.7-1.7V111.6z M215.7,119.1v3.2l2.7-1.7v-3.2L215.7,119.1z M223.5,114.5l-2.7,1.7v3.2l2.7-1.7V114.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.6773,
    y1: 245.7022,
    x2: 246.9331,
    y2: 136.5509,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M238.5,112.6l-2.7,1.7v3.2l2.7-1.7V112.6z M233.5,115.5l-2.7,1.7v3.2l2.7-1.7V115.5z M228.5,118.4l-2.7,1.7 v3.2l2.7-1.7V118.4z M215.7,125.8v3.2l2.7-1.7v-3.2L215.7,125.8z M223.5,121.2l-2.7,1.7v3.2l2.7-1.7V121.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.0961,
    y1: 246.0174,
    x2: 248.3519,
    y2: 136.8662,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M238.5,119.3l-2.7,1.7v3.2l2.7-1.7V119.3z M233.5,122.2l-2.7,1.7v3.2l2.7-1.7V122.2z M228.5,125.1l-2.7,1.7 v3.2l2.7-1.7V125.1z M215.7,132.5v3.2l2.7-1.7v-3.2L215.7,132.5z M223.5,127.9l-2.7,1.7v3.2l2.7-1.7V127.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.515,
    y1: 246.3327,
    x2: 249.7707,
    y2: 137.1815,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M238.5,126l-2.7,1.7v3.2l2.7-1.7V126z M233.5,128.9l-2.7,1.7v3.2l2.7-1.7V128.9z M228.5,131.8l-2.7,1.7v3.2 l2.7-1.7V131.8z M215.7,139.2v3.2l2.7-1.7v-3.2L215.7,139.2z M223.5,134.7l-2.7,1.7v3.2l2.7-1.7V134.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.9338,
    y1: 246.6479,
    x2: 251.1896,
    y2: 137.4967,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M238.5,132.7l-2.7,1.7v3.2l2.7-1.7V132.7z M233.5,135.6l-2.7,1.7v3.2l2.7-1.7V135.6z M228.5,138.5l-2.7,1.7 v3.2l2.7-1.7V138.5z M215.7,145.9v3.2l2.7-1.7v-3.2L215.7,145.9z M223.5,141.4l-2.7,1.7v3.2l2.7-1.7V141.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.3694,
    y1: 96.1873,
    x2: 210.6622,
    y2: 156.6148,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "184.6,47.4 212.7,63.7 241.2,47.3 213,31 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.3239,
    y1: 258.1525,
    x2: 279.6821,
    y2: 235.8871,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "199.3,146.9 199.3,166.8 212.7,159.1 212.7,139.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.14,
    y1: 263.5381,
    x2: 231.2807,
    y2: 243.3314,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "199.3,146.9 199.3,166.8 171.2,150.5 171.2,130.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.9624,
    y1: 255.005,
    x2: 230.6323,
    y2: 244.3242,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45108A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05041277,
    style: {
      stopColor: "#521B8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2999,
    style: {
      stopColor: "#8F4D8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5285,
    style: {
      stopColor: "#BF758B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7286,
    style: {
      stopColor: "#E2918C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8926,
    style: {
      stopColor: "#F7A38C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA98C"
    }
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "199.3,149.4 199.3,151.7 212.7,143.9 212.7,141.7 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.5225,
    y1: 255.1348,
    x2: 228.2839,
    y2: 237.7032,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0757576,
    style: {
      stopColor: "#45108A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1398,
    style: {
      stopColor: "#541D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    style: {
      stopColor: "#7D3E8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    style: {
      stopColor: "#BE738B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    style: {
      stopColor: "#FFA98C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7103,
    style: {
      stopColor: "#FFB892"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9407,
    style: {
      stopColor: "#FEE1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEECA8"
    }
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "199.3,149.4 199.3,151.7 171.2,135.3 171.2,133 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.6045,
    y1: 211.8715,
    x2: 190.8322,
    y2: 241.9304,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "171.2,130.5 199.3,146.9 212.7,139.1 184.5,122.7 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.15,
    y1: 265.1041,
    x2: 185.15,
    y2: 205.0731,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M193.8,152v11.4l2.7,1.7v-11.4L193.8,152z M173.8,151.9l2.7,1.7v-11.4l-2.7-1.7V151.9z M178.8,154.8l2.7,1.7 V145l-2.7-1.7V154.8z M183.8,157.6l2.7,1.7v-11.4l-2.7-1.7V157.6z M188.8,160.5l2.7,1.7v-11.4l-2.7-1.7V160.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.15,
    y1: 268.6537,
    x2: 206.15,
    y2: 228.9728,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#7C1DC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#6E41D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    style: {
      stopColor: "#4C9BE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AF6FF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M202.3,153.7v11.4l2.7-1.7V152L202.3,153.7z M210,149.1l-2.7,1.7v11.4l2.7-1.7V149.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.2182,
    y1: 157.7025,
    x2: 268.1156,
    y2: 143.3602,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "212.8,56.1 212.8,59.9 235,47.2 235,43.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.4393,
    y1: 163.4171,
    x2: 233.5208,
    y2: 149.5004,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "212.8,56.1 212.8,59.9 190.9,47.2 190.9,43.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.3329,
    y1: 156.2181,
    x2: 266.7057,
    y2: 142.3325,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#6B24D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    style: {
      stopColor: "#7733DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    style: {
      stopColor: "#975CED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56EF4"
    }
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "212.8,56.1 212.8,57 235,44.3 235,43.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.4269,
    y1: 161.7457,
    x2: 232.4875,
    y2: 148.282,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#6B24D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    style: {
      stopColor: "#7733DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    style: {
      stopColor: "#975CED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56EF4"
    }
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "212.8,56.1 212.8,57 190.9,44.3 190.9,43.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.9144,
    y1: 104.5346,
    x2: 211.1906,
    y2: 151.6531,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "190.9,43.3 212.8,56.1 235,43.3 213,30.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.4806,
    y1: 149.7047,
    x2: 243.3482,
    y2: 141.6596,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "212.9,43.8 212.9,50.9 224.1,44.4 224.1,37.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.3459,
    y1: 152.973,
    x2: 225.2497,
    y2: 145.1487,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "212.9,43.8 212.9,50.9 201.9,44.4 201.9,37.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.6535,
    y1: 148.3029,
    x2: 241.1799,
    y2: 140.9589,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45108A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05041277,
    style: {
      stopColor: "#521B8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2999,
    style: {
      stopColor: "#8F4D8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5285,
    style: {
      stopColor: "#BF758B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7286,
    style: {
      stopColor: "#E2918C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8926,
    style: {
      stopColor: "#F7A38C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA98C"
    }
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "212.9,44.7 212.9,47.3 224.1,40.9 224.1,38.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.8494,
    y1: 151.2359,
    x2: 223.6497,
    y2: 144.1073,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0757576,
    style: {
      stopColor: "#45108A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1398,
    style: {
      stopColor: "#541D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    style: {
      stopColor: "#7D3E8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    style: {
      stopColor: "#BE738B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    style: {
      stopColor: "#FFA98C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7103,
    style: {
      stopColor: "#FFB892"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9407,
    style: {
      stopColor: "#FEE1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEECA8"
    }
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "212.9,44.7 212.9,47.3 201.9,40.9 201.9,38.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.5878,
    y1: 120.2661,
    x2: 212.1243,
    y2: 144.019,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25054D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45108A"
    }
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "201.9,37.4 212.9,43.8 224.1,37.3 213.1,30.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.6671,
    y1: 232.034,
    x2: 183.8053,
    y2: 180.0921,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#9F19AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    style: {
      stopColor: "#AE25B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4123,
    style: {
      stopColor: "#D744BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    style: {
      stopColor: "#FF63CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    style: {
      stopColor: "#DC48C1"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M196.1,76.6c-4.7-2.7-8.9-2.8-11.8-0.8l-3.4,1.6l0.4,2.2c-0.7,1.7-1.1,3.7-1.1,6.1c0,6.9,3.7,17.8,7.5,27.2 l4,20.8l4.4-2.2c0,0,15.9-13.1,15.9-27.4C212,93.9,204.8,81.7,196.1,76.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.4366,
    y1: 226.5328,
    x2: 210.8797,
    y2: 190.3199,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#9F19AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    style: {
      stopColor: "#AE25B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    style: {
      stopColor: "#D744BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF63CE"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M207.6,106.2c0,14.3-15.9,27.4-15.9,27.4s-15.9-31.5-15.9-45.8c0-10.1,7.1-14.1,15.9-9 C200.5,83.9,207.6,96.1,207.6,106.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_117_",
    cx: 199.5972,
    cy: 201.1737,
    r: 22.3615,
    gradientTransform: "matrix(1 0 0 1 0 -105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M192.7,78.3c-4.6-2.6-8.7-2.8-11.6-0.9c2.8-1.3,6.5-0.9,10.6,1.4c8.8,5.1,15.9,17.3,15.9,27.4 c0,12.3-11.6,23.6-15,26.7c0.1,0.1,0.1,0.2,0.1,0.2s15.9-13.1,15.9-27.4C208.6,95.6,201.5,83.3,192.7,78.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: -373.1178,
    y1: 2387.7803,
    x2: -383.3602,
    y2: 2380.0376,
    gradientTransform: "matrix(0.866 0.5 0 1.1547 519.1736 -2466.6589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#9D9EB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    style: {
      stopColor: "#D4D1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEEBF2"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M197.5,100.4c0,3.7-2.6,5.1-5.8,3.3c-3.2-1.8-5.8-6.3-5.8-10s2.6-5.1,5.8-3.3S197.5,96.7,197.5,100.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M193.5,102.8c-3.2-1.8-5.8-6.3-5.8-10c0-1.4,0.4-2.5,1.1-3.2c-1.7,0.2-2.9,1.6-2.9,4.1c0,3.7,2.6,8.1,5.8,10 c1.9,1.1,3.6,1,4.7-0.1C195.5,103.7,194.5,103.4,193.5,102.8z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M180.2,335.4L13,239.3l30.5-28.8l153.2,88.2c3.4,2,7.6,2,11,0.1l26.5-14.5l6.6-29.8c0.6-1.4,1.7-2.7,3.1-3.4 l7.3-4.1l16.9,10.5l-4.1,2.6c-1.6,1-2.5,2.9-2.3,4.8l1.7,29c0.5,4.6-1.7,9-5.7,11.3l-52.8,30.1C197.2,339.8,187.8,339.8,180.2,335.4 z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M195.2,320.1c-0.7,0-1.3-0.1-2-0.2l0.2-1c1.1,0.2,2.2,0.2,3.3,0l0.1,1C196.4,320,195.8,320.1,195.2,320.1z  M200.4,318.8l-0.4-0.9c0.2-0.1,0.3-0.2,0.5-0.3l2.6-1.4l0.5,0.9l-2.6,1.4C200.7,318.7,200.6,318.8,200.4,318.8z M189.8,318.7 c-0.1-0.1-0.2-0.1-0.3-0.2l-2.7-1.6l0.5-0.9l2.7,1.6c0.1,0.1,0.2,0.1,0.3,0.2L189.8,318.7z M206.5,315.4l-0.5-0.9l3.1-1.7l0.5,0.9 L206.5,315.4z M183.7,315.2l-3-1.7l0.5-0.9l3,1.7L183.7,315.2z M212.6,312l-0.5-0.9l3.1-1.7l0.5,0.9L212.6,312z M177.7,311.8l-3-1.7 l0.5-0.9l3,1.7L177.7,311.8z M218.8,308.6l-0.5-0.9l3.1-1.7l0.5,0.9L218.8,308.6z M171.6,308.3l-3-1.7l0.5-0.9l3,1.7L171.6,308.3z  M224.9,305.2l-0.5-0.9l3.1-1.7l0.5,0.9L224.9,305.2z M165.5,304.8l-3-1.7l0.5-0.9l3,1.7L165.5,304.8z M231,301.8l-0.5-0.9l3.1-1.7 l0.5,0.9L231,301.8z M159.5,301.3l-3-1.7l0.5-0.9l3,1.7L159.5,301.3z M237.1,298.4l-0.5-0.9l3.1-1.7l0.5,0.9L237.1,298.4z  M153.4,297.8l-3-1.7l0.5-0.9l3,1.7L153.4,297.8z M243.2,295l-0.5-0.9l2.5-1.4c0.2-0.1,0.4-0.2,0.5-0.3l0.6,0.8 c-0.2,0.1-0.4,0.3-0.6,0.4L243.2,295z M147.3,294.3l-3-1.7l0.5-0.9l3,1.7L147.3,294.3z M141.2,290.9l-3-1.7l0.5-0.9l3,1.7 L141.2,290.9z M248.7,290.4l-0.9-0.4c0.4-0.9,0.7-1.9,0.7-2.9v-0.3h1v0.3C249.5,288.2,249.2,289.3,248.7,290.4z M135.2,287.4l-3-1.7 l0.5-0.9l3,1.7L135.2,287.4z M129.1,283.9l-3-1.7l0.5-0.9l3,1.7L129.1,283.9z M249.5,283.3h-1v-3.5h1V283.3z M123,280.4l-3-1.7 l0.5-0.9l3,1.7L123,280.4z M116.9,276.9l-3-1.7l0.5-0.9l3,1.7L116.9,276.9z M249.5,276.3h-1v-3.5h1V276.3z M110.9,273.5l-3-1.7 l0.5-0.9l3,1.7L110.9,273.5z M104.8,270l-3-1.7l0.5-0.9l3,1.7L104.8,270z M249.5,269.3h-1v-3.5h1V269.3z M98.7,266.5l-3-1.7l0.5-0.9 l3,1.7L98.7,266.5z M92.7,263l-3-1.7l0.5-0.9l3,1.7L92.7,263z M249.9,262.5l-0.9-0.3c0.4-1.2,1.2-2.2,2.1-3l0.7,0.8 C250.9,260.6,250.3,261.5,249.9,262.5z M86.6,259.5l-3-1.7l0.5-0.9l3,1.7L86.6,259.5z M254.6,258l-0.5-0.8l3-1.9l0.5,0.8L254.6,258z  M80.5,256l-3-1.7l0.5-0.9l3,1.7L80.5,256z M74.4,252.6l-3-1.7l0.5-0.9l3,1.7L74.4,252.6z M68.4,249.1l-3-1.7l0.5-0.9l3,1.7 L68.4,249.1z M62.3,245.6l-3-1.7l0.5-0.9l3,1.7L62.3,245.6z M56.2,242.1l-3-1.7l0.5-0.9l3,1.7L56.2,242.1z M50.2,238.6l-3-1.7 l0.5-0.9l3,1.7L50.2,238.6z M44.1,235.1l-3-1.7l0.5-0.9l3,1.7L44.1,235.1z M38,231.7l-3-1.7l0.5-0.9l3,1.7L38,231.7z M31.9,228.2 l-3-1.7l0.5-0.9l3,1.7L31.9,228.2z M25.9,224.7l-3-1.7l0.5-0.9l3,1.7L25.9,224.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.783,
    y1: 269.232,
    x2: 221.5255,
    y2: 210.0554,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#9F19AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    style: {
      stopColor: "#AE25B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    style: {
      stopColor: "#D744BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF63CE"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M312.3,109.4L232,155.8c-5.7,3.3-5.7,8.6,0.1,12l11.6,6.8c5.7,3.3,15,3.3,20.7,0l1.7-1h20.3l-0.1-11.7 l58.5-33.8c5.7-3.3,5.7-8.6-0.1-12l-11.6-6.8C327.3,106.1,318,106.1,312.3,109.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.3777,
    y1: 286.3515,
    x2: 286.3906,
    y2: 257.0714,
    gradientTransform: "matrix(1 0 0 1 0 -105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    style: {
      stopColor: "#FFA98C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    style: {
      stopColor: "#FFB892"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    style: {
      stopColor: "#FEE1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEECA8"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M295.7,174.3l58.9-33.7c5.7-3.3,15-3.3,20.7,0l11.6,6.8c5.7,3.3,5.8,8.7,0.1,12l-1.7,1l0.1,11.7h-20.2l-37,21 c-5.7,3.3-15,3.3-20.7,0l-11.6-6.8C290,183,290,177.6,295.7,174.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_121_",
    cx: 317.5833,
    cy: 246.7085,
    r: 26.3941,
    gradientTransform: "matrix(1 0 0 1 0 -105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M344.7,126.7l-58.5,33.8v1.5l58.5-33.8c3.2-1.8,4.6-4.3,4.2-6.7C348.6,123.4,347.2,125.2,344.7,126.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_122_",
    cx: 256.9667,
    cy: 273.9825,
    r: 21.5166,
    gradientTransform: "matrix(1 0 0 1 0 -105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M266,172.1l-1.7,1c-5.7,3.3-15,3.3-20.7,0l-11.6-6.8c-2.6-1.5-4-3.4-4.3-5.3c-0.4,2.4,1,4.9,4.3,6.8 l11.6,6.8c5.7,3.3,15,3.3,20.7,0l1.7-1h20.3v-1.5H266z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_123_",
    cx: 388.2241,
    cy: 261.5925,
    r: 3.4151,
    gradientTransform: "matrix(1 0 0 1 0 -105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M386.9,158l-1.7,1v1.5l1.7-1c3.2-1.8,4.6-4.3,4.2-6.7C390.8,154.7,389.4,156.5,386.9,158z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_124_",
    cx: 338.4167,
    cy: 288.0875,
    r: 34.3321,
    gradientTransform: "matrix(1 0 0 1 0 -105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M365.1,170.6l-37,21c-5.7,3.3-15,3.3-20.7,0l-11.6-6.8c-2.6-1.5-4-3.4-4.3-5.3c-0.4,2.4,1,4.9,4.3,6.8 l11.6,6.8c5.7,3.3,15,3.3,20.7,0l37-21h20.3v-1.5H365.1z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M258.6,162.1c1-0.9,1.5-2,1.6-3c0-0.6-0.9-1.1-2-1.1c-1.4,0-2.9-0.1-4.2-0.5c-0.7,0.3-2,0.4-2.7-0.1 c-0.7-0.4-0.9-1-0.6-1.3c-2.8-1.8-4.2-4-0.1-6.3c4.1-2.3,7.8-1.6,10.9,0.1c0.6-0.2,1.6-0.1,2.3,0.4c0.7,0.4,0.5,1.1,0.1,1.6 c0.5,0.8,0.8,1.6,0.8,2.4c0,0.6,0.9,1.1,2,1.1c1.8,0,3.6-0.3,5.2-0.9c2.1-0.8,4.9-0.6,6.7,0.4l3.2,1.8c0.6,0.4,0.6,0.9,0,1.3 l-16.9,9.8c-0.6,0.4-1.6,0.4-2.2,0l-3.2-1.8C257.6,165,257.3,163.4,258.6,162.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "314,135.6 311.3,134.1 308,136 310.7,137.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "308.5,138.8 305.8,137.2 291,145.8 293.7,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "304.6,133.9 301.9,132.3 294.8,136.4 297.5,138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "295.3,139.2 292.6,137.7 287.3,140.8 290,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "306.8,132.6 320.3,124.8 317.7,123.2 304.1,131.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "285.1,142 279.9,145 282.6,146.6 287.8,143.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "309.5,123.9 320.9,117.3 318.2,115.8 306.8,122.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "288.8,147 286.1,148.6 288.8,150.1 291.5,148.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "282.2,136.6 273.7,141.4 276.4,143 284.9,138.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "304,127.1 307.3,125.2 304.6,123.6 301.3,125.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "287,136.9 301.8,128.3 299.1,126.8 284.4,135.3  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "342.2,162.8 339.5,161.3 336.2,163.2 338.9,164.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "327.7,175.3 315,182.6 317.7,184.1 330.3,176.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "317.1,174.2 308.8,179 311.5,180.6 319.8,175.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "336.7,166 334.1,164.4 319.3,173 322,174.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "337.9,172.5 335.2,170.9 329.9,174 332.5,175.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "344.5,165.6 337.4,169.7 340.1,171.2 347.2,167.1  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M373.6,148.5l-1.3,0.8l-5.5-2.3c-1.7-0.7-4.2-0.5-5.9,0.5l-12.8,7.4c-1.7,1-2,2.4-0.8,3.4l4,3.2l-1.3,0.8 c-0.6,0.4-0.6,0.9,0,1.3c0.6,0.4,1.6,0.4,2.2,0l0.8-0.4l5.2,3c1.2,0.7,3.2,0.7,4.4,0l0.7-0.4l1.7,1c0.6,0.3,1.5,0.3,2,0l1.6-0.9 c0.6-0.3,0.6-0.8,0-1.2l-1.7-1l9.2-5.3l1.7,1c0.6,0.3,1.5,0.3,2,0l1.6-0.9c0.6-0.3,0.6-0.8,0-1.2l-1.7-1l0.7-0.4 c1.2-0.7,1.2-1.9,0-2.6l-5.2-3l0.8-0.4c0.6-0.4,0.6-0.9,0-1.3C375.2,148.1,374.2,148.1,373.6,148.5z M349.1,157.5 c-0.6-0.4-0.3-1.2,0.6-1.7l12.8-7.4c0.9-0.5,2.2-0.7,2.9-0.3l5,2.1l-17.7,10.2L349.1,157.5z M356.6,163.7c-0.6-0.4-0.6-0.9,0-1.3 l1.4-0.8c0.6-0.4,1.6-0.4,2.2,0s0.6,0.9,0,1.3l-1.4,0.8C358.2,164,357.2,164,356.6,163.7z M373,157.3l-7.8,4.5l-1.9-1.1l7.8-4.5 L373,157.3z M376.2,153.6l-1.4,0.8c-0.6,0.4-1.6,0.4-2.2,0s-0.6-0.9,0-1.3l1.4-0.8c0.6-0.4,1.6-0.4,2.2,0 C376.8,152.7,376.8,153.3,376.2,153.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "350.7,150.1 348.5,151.4 350.8,152.7 353,151.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "355,150.2 357.2,149 355,147.7 352.8,149  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "350.5,147.6 348.3,148.8 350.5,150.1 352.8,148.8  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M123.8,237.3l5.2-3c0.7-0.4,1.2-1.5,1.2-2.4v-2.5c0-0.9-0.6-1.3-1.2-0.9l-5.2,3c-0.7,0.4-1.2,1.5-1.2,2.4 v2.5C122.5,237.2,123.1,237.7,123.8,237.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M130.6,228.9c0,0-0.7-0.6-1-0.5c-0.3,0,0.4,1.1,0.4,1.1L130.6,228.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M124,237.8c0,0-0.9-0.1-1.2-0.6c-0.2-0.4-0.1-0.9-0.1-0.9S124,236.9,124,237.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M124.6,237.7l5.2-3c0.7-0.4,1.2-1.5,1.2-2.4v-2.5c0-0.9-0.6-1.3-1.2-0.9l-5.2,3c-0.7,0.4-1.2,1.5-1.2,2.4 v2.5C123.3,237.6,123.9,238.1,124.6,237.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M80.5,279.3l15.2-8.9c0,0-2.7-5.2-9.2-3.4c-6.5,1.8-10.2,4.1-10.2,4.1L80.5,279.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M86.6,277c0,6.1,3.7,13.1,8.2,15.7s8.2-0.2,8.2-6.2c0-6.1-3.7-13.1-8.2-15.7 C90.3,268.2,86.6,270.9,86.6,277z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "100,293.3 94.7,296.4 84.7,273.2 90.2,270  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M81.3,280.1c0,6.1,3.7,13.1,8.2,15.7s8.2-0.2,8.2-6.2c0-6.1-3.7-13.1-8.2-15.7 C84.9,271.2,81.3,274,81.3,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M83.6,281.4c0,4.4,2.7,9.4,5.9,11.3c3.3,1.9,5.9-0.1,5.9-4.5s-2.7-9.4-5.9-11.3 C86.2,275.1,83.6,277.1,83.6,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M86.2,283.1c0,2.2,1.4,4.8,3,5.8c1.7,1,3-0.1,3-2.3c0-2.2-1.4-4.8-3-5.8C87.5,279.9,86.2,280.9,86.2,283.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M86.7,283.4c0,1.9,1.1,4,2.5,4.8s2.5-0.1,2.5-1.9c0-1.9-1.1-4-2.5-4.8C87.8,280.7,86.7,281.5,86.7,283.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M17.4,242.9l15.2-8.9c0,0-2.7-5.2-9.2-3.4s-10.2,4.1-10.2,4.1L17.4,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M4.8,211.1c0,0,18.2-14.7,32.7-18c6-1.4,12.5,1.6,17.5,2.1l5.4,5.2l-38.8,23.8l-15.9-8.5 C4.2,215,3.3,212,4.8,211.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M126.6,239.5c-1.7,2.1-5.2,5.3-12,10c-16.4,11.5-28.1,10.7-28.1,10.7l-9.1-16c9.5-4.4,23.9-10.7,30-11.9 C113.5,231.1,121.6,235.9,126.6,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M112.7,217.7l15.3,18.1c0,0,1.1,0.8-1.3,3.7c-5-3.6-13.1-8.4-19.2-7.2s-20.4,7.5-30,11.9l-2.5-4.4 L112.7,217.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M112.7,217.7c0,0-1.7,2.4-11.6,9.4c-9.3,6.5-26.1,12.7-26.1,12.7s-12-9.1-21.6-14.4 c-9.5-5.3-26.2-12.3-26.2-12.3L55,195.2c0,0,7.3-7.2,19.9-0.7c4.7,2.5,13.3,7.7,25.3,15C104.7,212.3,109.1,215.3,112.7,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M111.5,219.7c0,0-8.4-5.1-20.3-11.9c-11.9-6.8-27.4-15.7-27.4-15.7l-1.4,0.5c0,0,6.4,3.9,12.5,7.2 c4.9,2.7,36.1,20.9,36.1,20.9L111.5,219.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M82,237c0,0-8.4-5.1-20.3-11.9c-11.9-6.8-27.4-15.7-27.4-15.7l-1.4,0.5c0,0,6.4,3.9,12.5,7.2 c4.9,2.7,36.1,20.9,36.1,20.9L82,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M31,211.1l-8,1.4l-8.1,4.5c0,0,15.8-2.1,17.4-2.7C33.9,213.6,31,211.1,31,211.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M23.5,240.6c0,6.1,3.7,13.1,8.2,15.7s8.2-0.2,8.2-6.2c0-6.1-3.7-13.1-8.2-15.7 C27.2,231.7,23.5,234.5,23.5,240.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "36.9,256.9 31.6,260 21.6,236.8 27.1,233.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M18.2,243.7c0,6.1,3.7,13.1,8.2,15.7s8.2-0.2,8.2-6.2c0-6.1-3.7-13.1-8.2-15.7 C21.8,234.8,18.2,237.6,18.2,243.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M20.5,245c0,4.4,2.7,9.4,5.9,11.3c3.3,1.9,5.9-0.1,5.9-4.5s-2.7-9.4-5.9-11.3 C23.1,238.7,20.5,240.7,20.5,245z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M23.1,246.7c0,2.2,1.4,4.8,3,5.8c1.7,1,3-0.1,3-2.3s-1.4-4.8-3-5.8C24.4,243.4,23.1,244.5,23.1,246.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M23.6,247c0,1.9,1.1,4,2.5,4.8s2.5-0.1,2.5-1.9c0-1.9-1.1-4-2.5-4.8S23.6,245.1,23.6,247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M4.8,211.1c3.6,0.7,6.8,5.9,13.3,4.7c1.8-0.3,7.3-2.4,11.9-2.1c4.8,0.3,7.5,2.1,11.9,4.7 c3.5,2,15.8,9,25.2,15c5.3,3.4,8.9,5.4,10.3,7.7c1,1.6,4.3,9.4,7.6,15.5c0.7,1.2,1.5,2.4,2.4,3.4l59.7-11c0,0,3.4,3.5,5.5,9.8 c0.8,2.4,3.3,8.4,2.1,13.8c-1.1,4.9-4.5,10.1-10.9,13.7c-21.8,12.6-34.1,9.7-43.2,4.7c0-8-4.9-17.3-11-20.8 c-6-3.5-10.9,0.2-10.9,8.2C65.9,271,49.5,261.6,36.4,254c-0.3-2.1-1.4-9-2.6-11c-2.3-4-8.3-9.6-10.9-9.3 c-8.4,0.8-4.9,9.7-6.4,8.8c-2.1-1.2-3.2-1.9-3.2-1.9c-6.6-3.8-10-11.3-11-16.1C1.7,221.8,1.9,213.1,4.8,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M15.6,240.5c0-8.9,5.5-13,12.2-9.1c2.9,1.7,5.6,4.6,7.8,8.2c1.1,0.7,2.3,1.4,3.5,2.2 c6.4,4.1,33.8,19.7,43.9,25.5c2.1-1.2,4.9-1,7.9,0.7c6.7,3.9,12.2,14.3,12.2,23.2c-0.3-0.2-0.6-0.4-0.9-0.5 c-0.2-0.1-0.6-0.4-1.3-0.8c0-0.1-1.4-0.6-1.4-0.7c0-7.4-4.1-15.5-9.7-18.8c-1.2-0.7-2.3-1.1-3.3-1.2c0.2,0.1,0.3,0.2,0.3,0.2 l-3.5,0.7c-1.6,1.3-2.6,4.1-2.6,7.8c0,0.1,0,0.2,0,0.2c-0.6-0.4-1.3-0.8-2-1.1c0-3.2,0.7-5.8,2-7.6c0,0-20.4-11.4-27.2-15.2 c-3.7-2.1-14.5-7-14.5-7c0.6,1.4,0.9,3.8,1.1,7.3c-0.3-0.2-0.6-0.4-0.9-0.5c-0.2-0.1-0.6-0.4-1.3-0.8c0-0.1-1.4-0.6-1.4-0.7 c0-2.9-0.7-6-1.8-8.8l-0.4-0.2l-3.4-5l-4.6-4.4c-0.7-0.5,0.7,0.2,3.3,1.8c-0.9-0.8-1.8-1.5-2.7-2.1c-5.6-3.2-9.7,0.1-9.7,7.5 c0,0.1,0.6,0.3,0.6,0.3C16.9,241.2,16.3,240.8,15.6,240.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M89.7,270.1c6,3.5,10.9,12.8,11,20.8c-0.3-0.2-0.6-0.3-0.8-0.5c-0.2-0.1-0.6-0.3-1.2-0.7 c0-0.1,0-0.1,0-0.2c0-6.7-4.1-14.4-9.1-17.3s-9,0.2-9,6.8c0,0.1,0,0.1,0,0.2c-0.6-0.3-1.2-0.7-1.8-1 C78.8,270.3,83.7,266.7,89.7,270.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M51.3,197.5c0,0-5.7-3.8-12.2-2.3c-6.6,1.5-13.9,6.7-13.9,6.7l11.4,4.6L51.3,197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M26.6,233.7c6,3.5,10.9,12.8,11,20.8c-0.3-0.2-0.6-0.3-0.8-0.5c-0.2-0.1-0.6-0.3-1.2-0.7c0-0.1,0-0.1,0-0.2 c0-6.7-4.1-14.4-9.1-17.3c-5-2.9-9,0.2-9,6.8c0,0.1,0,0.1,0,0.2c-0.6-0.3-1.2-0.7-1.8-1C15.7,233.9,20.6,230.3,26.6,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M128,235.8c0,0,7.5,5.3,17.9,12.2c5.1,3.4,6.9,13.1-5.1,21c-14.1,9.2-24.7,8.2-33.7,3 c-9.6-5.6-20.5-11.8-20.5-11.8s7.4,0,22.1-8.8C120.7,244.3,128,235.8,128,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M121.7,273.2l-26.2-14.9l-3.4,1.4C92.2,259.7,114.2,273.6,121.7,273.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M126.8,237.9c0,0,12.4,8,17.2,11.9c4.8,4,2.4,9.7,2.4,9.7l-27.4-16L126.8,237.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M80,259.1c1.2,0.7,2.5-0.5,2-1.8c-2.5-5.8-7.2-16.4-9.2-17.7c-2.6-1.7-11.7-7.1-22.9-13.7 c-8.2-4.9-15.5-9.1-19-8.2c-1.3,0.4-5,2.9-7.7,4.8c-1.4,1-1.3,3.2,0.2,4.1L80,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M64.4,191.8c0,0-11.2,6.1-16.2,9.4c-7.5,4.9-17.5,10.4-17.5,10.4l-11.4,2.9c3.1-1.9,0,0,6-3.4 c8.5-4.8,17.9-10.7,19.4-11.7c2.1-1.3,6.1-3.4,8.3-4.5C57.4,192.8,63,191.6,64.4,191.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M126.5,282.9c-1.2-2.3-3.3-4-5.9-3.7c-1.9,0.2-2.2-0.1-5.3-0.4c-3.5-0.3-6.7-1.8-8.4-2.9 c-2.2-1.3-2.4,0.9-2.2,1.8c0.9,3.2,3.4,5.6,6.7,6.6C119.1,286.9,126.5,282.9,126.5,282.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M129.9,275.1c-2.1,0.4-4.2,0.9-5.6,1.3l-0.4-0.4c0,0,9.9-2.2,16.8-7c4.5-3.1,6.6-6.6,6.6-6.6l0.2,0.9 c-0.5,0.9-1.3,2.1-2.5,3.7C142.3,270.5,133.4,274.4,129.9,275.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M130.6,276.9c-1.7,0.4-3.4,0.8-4.8,1.1l-0.8-1c1.5-0.3,3.6-0.8,5.6-1.3c3.8-1,9.3-3.9,12.9-6.3 c2.3-1.6,3.7-3.9,4.4-5.3l0.4,1.4c-0.5,0.8-1.3,1.9-2.5,3.3C142.7,272.1,134,276.2,130.6,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M144.8,273.4c2-1.4,3.3-3.3,4.1-4.7c0,1.4-0.5,2.7-1.6,3.6c-1.4,1.3-3.4,2.9-5.8,4.1 c-4.6,2.4-7.7,3.8-9.6,4.5c-1.2,0.5-2.6,0.3-3.7-0.4c1.2-0.3,2.4-0.6,3.7-0.9C135.7,278.7,141.2,275.8,144.8,273.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M144,271.3c2-1.4,3.5-3.3,4.4-4.8l0.3,1v0.1c-0.5,0.9-1.3,2-2.3,3.3c-2.8,3.5-11.7,7.4-15.1,8.2 c-1.3,0.3-2.7,0.6-3.9,0.9c0,0,0,0-0.1-0.1l-1-1.2c1.4-0.3,3.1-0.7,4.8-1.1C135,276.6,140.4,273.7,144,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M146.4,270.9c1-1.3,1.8-2.4,2.3-3.3c0.1,0.4,0.1,0.7,0.1,1.1c-0.8,1.4-2.1,3.3-4.1,4.7 c-3.6,2.4-9.1,5.3-12.9,6.3c-1.2,0.3-2.5,0.6-3.7,0.9c-0.3-0.2-0.6-0.4-0.8-0.7c1.2-0.3,2.6-0.6,3.9-0.9 C134.8,278.3,143.7,274.4,146.4,270.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M130.6,276.9c3.4-0.7,12.1-4.8,15.1-8.2c1.2-1.3,2-2.4,2.5-3.3l0.3,1c-0.9,1.4-2.4,3.4-4.4,4.8 c-3.6,2.4-9.1,5.3-12.9,6.3c-1.6,0.4-3.4,0.8-4.8,1.1l-0.6-0.7C127.1,277.7,128.9,277.3,130.6,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M143.4,269.4c-3.6,2.4-9.1,5.3-12.9,6.3c-2,0.5-4.1,1-5.6,1.3l-0.6-0.7c1.4-0.3,3.5-0.8,5.6-1.3 c3.4-0.7,12.3-4.6,15.1-8.1c1.3-1.6,2.1-2.8,2.5-3.7l0.2,0.9C147.1,265.6,145.7,267.9,143.4,269.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M150.4,253.6c0,0,0.2,3.1,0.3,6.5c0,2.5,1.1,6,1.1,6s1.3-4.8,1.1-6.5C152.5,256.1,150.4,253.6,150.4,253.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M150.4,278.5c0,0,0-6.2-3.9-3.5c-3.6,2.5-6.6,4.4-9.1,5.5c-2.9,1.4-5,2.3-5.8,3.9c-0.8,1.5-0.9,5.5-0.9,5.5 s2.7-0.1,12-5.4C149.8,280.5,150.4,278.5,150.4,278.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M147.5,275.9v3.7c0,0-2.9,2-5.2,3.5c-1.5,1-7.2,3.6-7.2,3.6v-3.6c0,0,4.1-1.8,7.2-3.7 C145.3,277.8,147.5,275.9,147.5,275.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M155,270.2c0,0,0.5,5.4-2.1,9.3c-2.7,3.9-9.5,10.9-21.5,14.3c-13.5,3.9-22.1,2.6-27.1,0.4s-5.6-2.1-5.7-4.4 s2-0.7,2-0.7s2.2,3.7,12.7,4.3c5.5,0.3,12.7-0.7,18.6-2.4c5.3-1.6,10.5-4.8,15.6-8.5C154.7,277.2,155,270.2,155,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M123.2,288c0.6,0,0.9,0.6,0.6,1.1c-0.3,0.6-0.8,1.3-1.3,1.8c-1.7,1.6-9.6,1.7-10.5,0.9s-0.3-3.4,1.8-3.3 C116.7,288.6,120.7,287.9,123.2,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M154.5,265c0,0-0.6,2.7-1,3.7s1.5,1.4,1.5,1.4S155,267,154.5,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M137.7,274.4c0.2,0.7,1.6,0.8,3,0.1c1.4-0.7,2.4-1.8,2.2-2.5s-1.6-0.8-3-0.1 C138.4,272.5,137.4,273.7,137.7,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M129.5,236.8c0,0-0.9,2.2-6.2,6.3c-5,3.9-16,11.7-23.2,14.6c-7.2,2.9-11.8,4.7-13.6,2.5 c-1.8-2.2-11-20.8-11-20.8l1-0.4c0,0,9.8,19,11,20.1c1.2,1,10.3-2.4,26.5-12.9c6.1-4,13.9-10.4,13.9-10.4L129.5,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M112.7,217.7l0.7,0.9c0,0-5.7,5.4-12.9,9.7c-7.2,4.3-24.3,12.1-24.3,12.1l-0.7-1c0,0,15.9-6.7,24.5-12.4 C108.7,221.3,112.7,217.7,112.7,217.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "36.2,251.3 79.6,276.3 79.6,278.8 78.9,278.4 35.7,253.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M56.4,231.2v12.6L75,254.5c0,0,0-4.8,0-6.7c0-1.1-0.4-2.7-1.2-4.3c-0.6-1.3-2.1-3-3.9-4.1 C65,236.3,56.4,231.2,56.4,231.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M54,230.1v12.6l-19.5-11.5c0,0,0-4.8,0.2-6.2c0.2-1.3,0.9-5.1,0.9-5.1L54,230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M33.8,219.4c0,0-0.7,3.6-0.9,4.8c-0.2,1.3-0.3,6-0.3,6s-4.4-2.7-5.5-3.2c-1-0.5-1.8-2,0.8-4 C30,221.5,33.8,219.4,33.8,219.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M3,215l0.3,0.2c0.7,0.5,1.2,1.3,1.2,2.2v2.9c0,2.5,0.4,5.2,0.4,5.2l-2.7-1.7c0,0-1.3-2.8-0.7-6 C1.8,215.7,3,215,3,215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M18.2,232.8c0,0-8.2-3.7-14-7.9c-0.9-0.7-2.4-2.3-2.4-2.3s-0.7,1.1,1.9,4.6c0.9,1.2,10,7.8,12.7,8.7 C17.6,232.9,18.2,232.8,18.2,232.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M75.4,264.7l5.2-3c0.7-0.4,1.2-1.5,1.2-2.4v-2.5c0-0.9-0.6-1.3-1.2-0.9l-5.2,3c-0.7,0.4-1.2,1.5-1.2,2.4 v2.5C74.1,264.7,74.7,265.1,75.4,264.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M82.2,256.3c0,0-0.7-0.6-1-0.5c-0.3,0,0.4,1.1,0.4,1.1L82.2,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M75.6,265.2c0,0-0.9-0.1-1.2-0.6c-0.2-0.4-0.1-0.9-0.1-0.9S75.6,264.3,75.6,265.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M76.1,265.1l5.2-3c0.7-0.4,1.2-1.5,1.2-2.4v-2.5c0-0.9-0.6-1.3-1.2-0.9l-5.2,3c-0.7,0.4-1.2,1.5-1.2,2.4 v2.5C74.9,265.1,75.4,265.5,76.1,265.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "91.6,218.1 79,225.4 79,219.1 91.6,211.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "91.1,217.7 79.5,224.4 79.5,219.5 91.1,212.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "75.5,217 75.5,223.4 79,225.4 79,219.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "75.5,217 79,219.1 91.6,211.7 88.4,209.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "67.1,264.6 70.2,266.4 70.2,262.3 67.1,260.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "64,258.7 67.1,260.5 67.1,256.4 64,254.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "60.9,261.1 64,262.9 64,258.7 60.9,256.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "54.7,257.5 57.8,259.3 57.8,255.1 54.7,253.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "57.8,255.1 60.9,256.9 60.9,252.8 57.8,251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "48.5,254 51.6,255.7 51.6,251.6 48.5,249.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "51.6,251.6 54.7,253.4 54.7,249.3 51.6,247.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "42.3,250.3 45.4,252.1 45.4,248 42.3,246.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "45.4,248 48.5,249.7 48.5,245.6 45.4,243.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSvg);
export default __webpack_public_path__ + "static/media/order-svg.d573d6671f71045469a2dcc7e349859e.svg";
export { ForwardRef as ReactComponent };